export default "__VITE_ASSET__927484e2__"